import isEmpty from 'lodash.isempty';
import {
    getCommonProficientLevel,
    PROFICIENT_LEVEL_MAPPER,
} from '../../../constants/reading/ProficientLevelMapper';
import { PROFICIENT_LEVEL } from '../../../constants/shared/TrcInterpretationMapper';
import { MEASURE } from '../../../constants/reading/MeasuresConstants';

const { DO } = MEASURE;
const { PROFICIENT } = PROFICIENT_LEVEL;

const parseDecodingInterps = interpResponse => {
    let interpretations = [];
    if (isEmpty(interpResponse)) return interpretations;
    interpretations = interpResponse.map(interpData => {
        const goal = interpData.proficiency_levels.find(
            item => item.interpretation.toLowerCase() === PROFICIENT,
        ).score_threshold;
        const thresholds = interpData.proficiency_levels.map(thresholdObject => ({
            scoreThreshold: thresholdObject.score_threshold,
            interp: getCommonProficientLevel(
                thresholdObject.interpretation,
                PROFICIENT_LEVEL_MAPPER,
            ),
        }));
        return {
            measure: DO,
            grade: interpData.grade_level,
            period: interpData.period,
            goal,
            thresholds,
        };
    });
    return interpretations;
};

export default parseDecodingInterps;
